const headerHeight = () => {
	// full height vh without header height
	const header = document.querySelector('.header');
	if (header !== null) {
		document.documentElement.style.setProperty(
			'--header-height',
			header.clientHeight + 'px'
		);
	}

	const navSticky = document.querySelector('.sticky-submenu');
	if (navSticky !== null) {
		document.documentElement.style.setProperty(
			'--sticky-submenu',
			navSticky.clientHeight + 'px'
		);
	}
};

export default headerHeight;
